import React from 'react';
import { Trans } from 'react-i18next';
import { createUseStyles } from 'react-jss';
import { useNavigate } from 'react-router-dom';

import { SubmitButton, TANDEMZ_PANEL } from '@app/core';
import { Theme } from '@app/theme';
import { AnalyticsCategoryProvider, Categories } from '@app/analytics';
import { AuthPane } from './AuthPane';
import { Participant, useAddToPanel } from '@app/api';
import { LinkSentence } from './components/LinkSentence';
import { SignupParticipantForm } from '@app/auth';

const useStyles = createUseStyles((theme: Theme) => ({
  h1: {
    ...theme.fonts.h3,
    marginBottom: theme.marginBase * 2,
  },
  loginContainer: {
    ...theme.fonts.label,
    padding: 0,
    marginTop: theme.marginBase * 3,
    fontWeight: 400,
  },
  login: {
    minWidth: 0,
    paddingLeft: theme.marginBase / 2,
    '&:hover:not(:disabled)': {
      backgroundColor: 'transparent',
    },
  },
  loginContent: {
    padding: 0,
    '& i': {
      fontWeight: 400,
      fontSize: theme.iconSize.small,
    },
  },
}));

interface Props {
  children?: React.ReactNode;
}

export const SignupParticipant = ({ children }: Props) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { mutateAsync: addToPanel } = useAddToPanel();

  const onSuccess = async (participant: Participant) => {
    await addToPanel({
      participantId: participant.id,
      panelId: TANDEMZ_PANEL,
    });
    navigate('/registration/verify-email');
  };

  return (
    <AnalyticsCategoryProvider category={Categories.SIGNUP}>
      <AuthPane>
        <h1 className={classes.h1}>
          <Trans i18nKey="auth.inscription.title" />
        </h1>
        <SignupParticipantForm onSuccess={onSuccess} trackingContext="organic">
          <SubmitButton>
            <Trans i18nKey="auth.inscription.submit" />
          </SubmitButton>
        </SignupParticipantForm>

        {/* t('auth.inscription.login') */}
        <LinkSentence text={'auth.inscription.login'} to="/login" />

        {children}
      </AuthPane>
    </AnalyticsCategoryProvider>
  );
};
